import { render, staticRenderFns } from "./homepageBanner.vue?vue&type=template&id=3b971d94&lang=pug&"
import script from "./homepageBanner.vue?vue&type=script&lang=js&"
export * from "./homepageBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports